// @ts-nocheck
import React from "react";
import { Box } from "theme-ui";
import { useThemeUI, useColorMode, } from 'theme-ui'
import JsxParser from 'react-jsx-parser'
import { DummyBackground } from "./layoutBackgroundComponents/dummy-background"; 
import { UnityPlayer } from "./unity-player"; 

export const LayoutComponentBackground = ( {properties, layoutBackgroundSubComponent} ) => {
    const { theme: { rawColors }, setColorModeTheme } = useThemeUI()
    const [colorMode, setColorMode] = useColorMode();

    if(properties == null)
        properties = {"color1":"background", "color2":"highlight"}

    console.log(properties);

    function isColorThemed(colorName)
    {
        switch(colorName)
        {
            case "background":
            case "accent":
            case "highlight":
            case "modes":
            case "muted":
            case "primary":
            case "secondary":
            case "text":
                return true;
        }
        return false;
    }

    function getPropColor(properties, prop, propAlt, type) 
    {
        if(!isUsingAltColors())
        {
            if(isColorThemed(prop))
            {
                return getColorFromThemeName(prop);
            }
            else 
            {
                return prop;
            }
        }
        else 
        {
            if(isColorThemed(propAlt))
            {
                return getColorFromThemeName(propAlt);
            }
            else 
            {
                return propAlt;
            }
        }
    }

    function getColorFromThemeName(colorProp)
    {
        if(colorProp != null)
        {
            switch(colorProp)
            {
                case "background":
                    return rawColors.background;
                case "accent":
                    return rawColors.accent;
                case "highlight":
                    return rawColors.highlight;
                case "modes":
                    return rawColors.modes;
                case "muted":
                    return rawColors.muted;
                case "primary":
                    return rawColors.primary;
                case "secondary":
                    return rawColors.secondary;
                case "text":
                    return rawColors.text;
                default:
                    return null;
            }
        }
    }

    function isUsingAltColors()
    {
        return colorMode == "dark";
    }

    const style = {
        fontFamily: "sans-serif",
        textAlign: "center",
        position: 'fixed',
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        // background: `linear-gradient(${properties == null ? rawColors.background : getProp_Color1()}, 
        //                              ${properties == null ? rawColors.highlight  : getProp_Color2()})`,

        background: `linear-gradient(${getPropColor(properties, properties.color1, properties.altcolor1, 1)}, 
                                     ${getPropColor(properties, properties.color2, properties.altcolor2, 2)})`,
        zIndex:"-1",
      };

    return (
        <Box style={{...style, }}>
            <Box>
                <JsxParser
                bindings={{ }}
                components={{ DummyBackground, UnityPlayer }}
                jsx= {layoutBackgroundSubComponent}
                />
            </Box>
            
        </Box>
        );
};
